import {
  BriefcaseIcon,
  ScaleIcon,
  ShieldCheckIcon,
  BanknotesIcon,
  DocumentCheckIcon,
  GlobeAltIcon,
  AcademicCapIcon,
  BuildingOfficeIcon,
  SparklesIcon,
} from "@heroicons/react/24/outline";
import { HashLink } from "react-router-hash-link";

const services = [
  {
    id: "litigation",
    title: "Litigation & Dispute Resolution",
    desc: "Civil, criminal, commercial disputes, judicial review, and public law litigation.",
    icon: ScaleIcon,
  },
  {
    id: "constitutional",
    title: "Constitutional & Human Rights Law",
    desc: "Upholding fundamental freedoms, constitutional compliance, and public interest litigation.",
    icon: ShieldCheckIcon,
  },
  {
    id: "labour",
    title: "Employment & Labour Relations",
    desc: "HR compliance, termination disputes, contracts, and union matters.",
    icon: BriefcaseIcon,
  },
  {
    id: "realestate",
    title: "Real Estate & Conveyancing",
    desc: "Property sales, title transfers, leases, and due diligence support.",
    icon: DocumentCheckIcon,
  },
  {
    id: "corporate",
    title: "Corporate & Commercial Law",
    desc: "Company formation, contracts, mergers, acquisitions, and regulatory advice.",
    icon: BuildingOfficeIcon,
  },
  {
    id: "banking",
    title: "Banking & Securities Law",
    desc: "Loan agreements, collateral perfection, and regulatory banking compliance.",
    icon: BanknotesIcon,
  },
  {
    id: "ip",
    title: "Intellectual Property Law",
    desc: "Trademark, copyright, and patent registration and protection.",
    icon: SparklesIcon,
  },
  {
    id: "environment",
    title: "Environment & Land Law",
    desc: "Environmental litigation, land use planning, zoning, and resource protection.",
    icon: GlobeAltIcon,
  },
  {
    id: "succession",
    title: "Succession, Wills & Trusts",
    desc: "Estate planning, wills drafting, probate, and charitable trust structuring.",
    icon: AcademicCapIcon,
  },
];

function ServicesSection() {
  return (
    <section id="services" className="bg-gray-100 text-deepgreen px-6 py-20">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-4xl font-extrabold mb-6" data-aos="fade-up">
          Legal Expertise You Can Trust
        </h2>
        <p
          className="text-lg mb-16 max-w-3xl mx-auto"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          We provide a wide range of legal services across sectors—delivering
          practical, results-oriented counsel with exceptional attention to legal
          detail, client care, and integrity.
        </p>

        <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white p-6 rounded-lg shadow hover:shadow-2xl hover:-translate-y-1.5 transform transition-all duration-300"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <service.icon className="h-10 w-10 text-gold mb-4 transition-transform duration-300 group-hover:scale-110" />
              <h3 className="text-xl font-bold mb-2">{service.title}</h3>
              <p className="text-sm mb-4">{service.desc}</p>
              <HashLink
                smooth
                to={`/#${service.id}-details`}
                className="inline-block mt-auto bg-gold text-deepgreen font-semibold py-2 px-4 rounded hover:bg-white hover:text-deepgreen border-2 border-gold transition"
              >
                Learn More
              </HashLink>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
